import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useEffect } from "react";

import { getDD_RUM } from "../datadog/rum";

export const useSetRouteContext = (
  productArea: string | undefined,
  pod: string | undefined,
  pillar: string | undefined,
  templatedPath: string | undefined
) => {
  // Update DD RUM context to capture new route metadata
  useEffect(() => {
    const normalizedProductArea = normalizeProductArea(productArea);
    const normalizedPod = normalizePod(pod);
    const normalizedPillar = normalizePillar(pillar);

    const existingRumContext = getDD_RUM()?.getGlobalContext?.() ?? {};
    const faire: any = existingRumContext.faire ?? {};
    faire.product_area = normalizedProductArea;
    faire.pod = normalizedPod;
    faire.pillar = normalizedPillar;
    getDD_RUM()?.setGlobalContextProperty?.("faire", faire);

    if (templatedPath) {
      getDD_RUM()?.setGlobalContextProperty?.("templatedPath", templatedPath);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      getWindowOrThrow().templatedPath = templatedPath;
    }
  }, [productArea, pod, pillar, templatedPath]);
};

const normalizeProductArea = (productArea: string | undefined) => {
  return productArea === "PRODUCT_AREA_UNKNOWN" ? undefined : productArea;
};

const normalizePod = (pod: string | undefined) => {
  return pod === "FAIRE_POD_UNKNOWN" ? undefined : pod;
};

const normalizePillar = (pillar: string | undefined) => {
  return pillar === "FAIRE_PILLAR_UNKNOWN" ? undefined : pillar;
};
